module.exports = __webpack_public_path__ + "img/mastercard.75dd059.svg";